import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useMenu } from '@bluheadless/ui-logic/src/hooks/menu/useMenu'
import { trimSlashes } from '@bluheadless/ui-logic/src/utils/url'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/system'
import { useRouter } from 'next/router'
import { array, number, oneOfType, string } from 'prop-types'
import SkeletonList from '../../../molecules/skeleton/list/skeleton-list'
import { Dropdown, Link, Root, SidebarLinks } from './customer-care-menu.styled'

const CustomerCareMenu = ({ activeMenuItem, ...props }) => {
	const {
		customerCare: {
			customerCareNestedLayout: { menuIdentifier },
		},
	} = useConfig()
	const { menu: customerCareMenu, loading: loadingCustomerCareMenu } = useMenu({ code: menuIdentifier })

	const theme = useTheme()
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))
	const router = useRouter()

	return loadingCustomerCareMenu && !customerCareMenu ? (
		<Root {...props}>
			<SkeletonList rows={mdUp ? 8 : 1} />
		</Root>
	) : customerCareMenu?.length ? (
		<Root {...props}>
			{mdUp ? (
				<SidebarLinks>
					{customerCareMenu?.map(({ id, url, title }, i) => (
						<Link
							key={i}
							underline="none"
							href={url}
							current={id === activeMenuItem || router?.query?.paths?.join('/') === trimSlashes(url)}
						>
							{title}
						</Link>
					))}
				</SidebarLinks>
			) : (
				<Dropdown
					name="customer-care-menu"
					value={
						customerCareMenu?.find(
							({ id, url }) => id === activeMenuItem || router?.query?.paths?.join('/') === trimSlashes(url)
						)?.url
					}
					onChange={(e) => {
						router.push(e.target.value)
					}}
					options={customerCareMenu?.map(({ url, title }) => ({ value: url, label: title }))}
				/>
			)}
		</Root>
	) : null
}

CustomerCareMenu.propTypes = {
	items: array,
	activeMenuItem: oneOfType([string, number]),
}

export default CustomerCareMenu
